import { exists } from '@/api'

export interface ReferenceImage {
  referenceImageMasterId: number
  title: string
  fileName: string
}

export function ReferenceImageFromJSON(json: any): ReferenceImage {
  return ReferenceImageJSONTyped(json)
}

export function ReferenceImageJSONTyped(json: any): ReferenceImage {
  if (json === undefined || json === null) {
    return json
  }
  return {
    referenceImageMasterId: exists(json, 'reference_image_master_id')
      ? json.reference_image_master_id
      : 0,
    title: exists(json, 'title') ? json.title : '',
    fileName: exists(json, 'file_name') ? json.file_name : ''
  }
}

export function ReferenceImageToJSON(value: ReferenceImage): any {
  return {
    reference_image_master_id: value.referenceImageMasterId,
    title: value.title,
    fileName: value.fileName
  }
}
